import React from "react";

import TextInput from "./TextInput";

const OpenQuestionInputs = ({ question, errors, handleChange }) => {
  return (
    <>
      <TextInput
        handleChange={handleChange}
        name={`label`}
        value={question?.label}
        errors={errors}
        label={"Question"}
        labelClassname={"font-bold"}
      />
      <TextInput
        value={question?.labelExternal}
        name={`labelExternal`}
        handleChange={handleChange}
        label={"External Question"}
        errors={errors}
        info={"Use {ORG_NAME} to insert the organization name in the question."}
        labelClassname={"font-bold"}
      />
    </>
  );
};

export default OpenQuestionInputs;
